// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"163a5b31","193":"2b909eca","202":"7b8c1b12","205":"7d75f972","453":"c61561b2"}[chunkId] + ".chunk.js";
};